import React, { useState } from 'react'
import { useRouter } from 'next/router'
import { useModal } from '@hooks/contexts/ModalContext/ModalContext'
import { useAuthentication } from '@hooks/useAuthentication'
import { MyWritingListType } from '@models/myWriting/MyWritingListType'
import { WritingListStatusEnum } from '@interfaces/WritingListStatusEnum'
import { Option } from '@interfaces/commons/Option'
import { ClockIcon } from '@components/icons/ClockIcon'
import { CancelTimeIcon } from '@components/icons/CancelTimeIcon'
import { MutiSelectTableProps, WithMutiSelectTableProps } from './interface'

export function withMutiSelectTable(Component: React.FC<MutiSelectTableProps>) {
  function WithMutiSelectTable({
    data,
    pageChange,
    ...props
  }: WithMutiSelectTableProps) {
    const [selectedIds, setSelectedIds] = useState<number[]>([])
    const storyModal = useModal({ modal: 'createStory' }, true)
    const router = useRouter()
    const { user } = useAuthentication()

    function openCreateStoryModal() {
      storyModal.show()
    }

    function handleSelectAll() {
      if (data.length === selectedIds.length) {
        setSelectedIds([])
      } else {
        setSelectedIds(data.map((row: any) => row.id))
      }
    }

    function handleSelect(value: number) {
      const index = selectedIds.findIndex((id: number) => id === value)

      if (index !== -1) {
        setSelectedIds((prev: number[]) => {
          const temp = [...prev]
          temp.splice(index, 1)

          return temp
        })
      } else {
        setSelectedIds((prev: number[]) => [...prev, value])
      }
    }

    function navigateToStoryEditPage(storyId: number) {
      router.push(`/my-writing/${storyId}/edit`)
    }

    function onPageChange(newPage: number) {
      setSelectedIds([])
      pageChange(newPage)
    }

    function storyMenuOptions(story: MyWritingListType) {
      const menus: Option[] = [
        {
          label: 'ลบ',
          value: WritingListStatusEnum.DELETE,
        },
      ]

      if (story.status === WritingListStatusEnum.PUBLISHED) {
        if (story.publishedUntil) {
          menus.unshift({
            label: 'ยกเลิกตั้งเวลาปิดเผยแพร่',
            value: WritingListStatusEnum.CANCEL_END_SCHEDULE,
            icon: <CancelTimeIcon className='w-4 h-4 mr-[6px]' />,
          })
        }
        if (!story.publishedUntil) {
          menus.unshift({
            label: 'ตั้งเวลาปิดเผยแพร่',
            value: WritingListStatusEnum.END_SCHEDULE,
            icon: <ClockIcon className='w-4 h-4 mr-[6px]' />,
          })
        }
      }

      return menus
    }

    const pageProps = {
      ...props,
      data,
      selectedIds,
      writingDisabled: user.writingDisabled,
      handleSelectAll,
      handleSelect,
      openCreateStoryModal,
      navigateToStoryEditPage,
      pageChange: onPageChange,
      storyMenuOptions,
    }

    return <Component {...pageProps} />
  }
  return WithMutiSelectTable
}
